import { Button } from '@/components/ui';
import useFavoritesStore from '@/store/use-favorites-store';
import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { StarIcon, StarFilledIcon } from '@radix-ui/react-icons';

interface WatchListToggleProps {
  symbol: string;
}

export default function WatchListToggle(props: WatchListToggleProps) {
  const { symbol } = props;

  const { t } = useTranslation();
  const isFavorite = useFavoritesStore((state) => state.getIsFavorite(symbol));

  const onClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const { toggleFavorite } = useFavoritesStore.getState();
    toggleFavorite(symbol);
  };

  return (
    <Button
      className="h-8 gap-2"
      type="button"
      size="sm"
      variant={isFavorite ? 'contrast' : 'outline'}
      onClick={onClick}
    >
      {isFavorite ? (
        <StarFilledIcon width={14} height={14} />
      ) : (
        <StarIcon width={14} height={14} />
      )}

      <span className="hidden sm:block">
        {isFavorite ? t('watchListToggle.added') : t('watchListToggle.add')}
      </span>
    </Button>
  );
}
